<template>
  <nav class="c-residence-navigation">
    <list-view-selector />
    <div>
      Sortering: 
      <Sorter />
    </div>
    <select-residence-status />
  </nav>
</template>

<script>

// Components
import SelectResidenceStatus from '@/components/SelectResidenceStatus.vue';
import Sorter from '@/components/Sorter.vue';
import ListViewSelector from '@/components/ListViewSelector.vue';

export default {
  name: 'ResidenceNavigation',
  components: {
    SelectResidenceStatus,
    Sorter,
    ListViewSelector,
  },
  computed: {
    listType() {
      return this.$store.state.entities.residences.listType;
    },
  },
};
</script>
